import React from "react";
import { Provider } from "react-redux";
import { render } from "react-snapshot";
import AppRouter from "./routers/AppRouter";
import registerServiceWorker from "./registerServiceWorker";
import configureStore from "./store/configureStore";
import { setProjects } from "./actions/projects";
import projects from "./components/Projects/ProjectsData";
import "./index.css";
import "./fonts/zona-pro/font.css";
import "./fonts/zona-pro-bold/font.css";

const store = configureStore();
store.dispatch(setProjects(projects));

const jsx = (
  <Provider store={store}>
    <AppRouter />
  </Provider>
);

render(jsx, document.getElementById("root"));

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js